import { render, staticRenderFns } from "./ListEmojis.vue?vue&type=template&id=f65bbde8&scoped=true"
import script from "./ListEmojis.vue?vue&type=script&lang=js"
export * from "./ListEmojis.vue?vue&type=script&lang=js"
import style0 from "./ListEmojis.vue?vue&type=style&index=0&id=f65bbde8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65bbde8",
  null
  
)

export default component.exports